/*!
 * Author: Antonio Sejas
 * Licensed GPLv3 for open source use
 *
 * http://sejas.es
 * Copyright 2016 Antonio Sejas
 */

var debug = false;
if (debug) {
   document.querySelectorAll('html')[0].classList.add("debug")
}

 document.addEventListener("DOMContentLoaded", hardandclassReady);

 function hardandclassReady (){
 	var config_flickity = {
 		prevNextButtons: false,
 		pageDots: false,
 		cellAlign: 'left',
 		autoPlay: true
 	}
   if ("undefined" != typeof Flickity) {
    if (document.querySelector('.products')) {
      var flky = new Flickity( '.products',config_flickity );
      document.querySelector('.show_more .left').addEventListener('click', function(e) {
         e.preventDefault();
         flky.previous()
         flkyPause()
      })
      document.querySelector('.show_more .right').addEventListener('click', function(e) {
         e.preventDefault();
         flky.next()
         flkyPause()
      })
    }

      if (document.querySelector('.products2')) {
        var flky2 = new Flickity( '.products2',config_flickity );
        if (document.querySelector('.show_more2 .left')) {
          document.querySelector('.show_more2 .left').addEventListener('click', function(e) {
             e.preventDefault();
             flky2.previous()
             flkyPause()
          })
        }
        if (document.querySelector('.show_more2 .right')) {
          document.querySelector('.show_more2 .right').addEventListener('click', function(e) {
             e.preventDefault();
             flky2.next()
             flkyPause()
          })
        }
      }
   }

 	var isPaused = false;
 	function flkyPause() {
 		if(!isPaused){
 			flky.player.pause()
 			isPaused = true
 		}
 	}
 }
 var default_flickity ={
   // options, defaults listed
   accessibility: true,
   // enable keyboard navigation, pressing left & right keys
   autoPlay: false,
   // advances to the next cell
   // if true, default is 3 seconds
   // or set time between advances in milliseconds
   // i.e. `autoPlay: 1000` will advance every 1 second
   cellAlign: 'center',
   // alignment of cells, 'center', 'left', or 'right'
   // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)
   cellSelector: undefined,
   // specify selector for cell elements
   contain: false,
   // will contain cells to container
   // so no excess scroll at beginning or end
   // has no effect if wrapAround is enabled
   draggable: true,
   // enables dragging & flicking

   freeScroll: false,
   // enables content to be freely scrolled and flicked
   // without aligning cells
   friction: 0.2,
   // smaller number = easier to flick farther
   initialIndex: 0,
   // zero-based index of the initial selected cell
   lazyLoad: true,
   // enable lazy-loading images
   // set img data-flickity-lazyload="src.jpg"
   // set to number to load images adjacent cells
   percentPosition: true,
   // sets positioning in percent values, rather than pixels
   // Enable if items have percent widths
   // Disable if items have pixel widths, like images
   prevNextButtons: true,
   // creates and enables buttons to click to previous & next cells
   pageDots: true,
   // create and enable page dots
   resize: true,
   // listens to window resize events to adjust size & positions
   rightToLeft: false,
   // enables right-to-left layout
   setGallerySize: true,
   // sets the height of gallery
   // disable if gallery already has height set with CSS
   watchCSS: false,
   // watches the content of :after of the element
   // activates if #element:after { content: 'flickity' }
   // IE8 and Android 2.3 do not support watching :after
   // set watch: 'fallbackOn' to enable for these browsers
   wrapAround: false
   // at end of cells, wraps-around to first for infinite scrolling
 };




 // Suscribe
var baUtils = (function(){
   var   u = {},
         debug = false
   
   u.isEmail =  function isEmail(email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
   }
   
   u.log = (debug)?console.log.bind(console):function(){}


   u.serialize = function(obj, prefix) {
     var str = [];
     for(var p in obj) {
       if (obj.hasOwnProperty(p)) {
         var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
         str.push(typeof v == "object" ?
           serialize(v, k) :
           k + "=" + v);
           // encodeURIComponent(k) + "=" + encodeURIComponent(v));
       }
     }
     return str.join("&");
   }
   u.sending = false
   u.post = function(url,params,ok,ko){
      if (!u.sending) {
         u.sending = true
         var r = new XMLHttpRequest(); 
         r.open("POST", url); //,true
         // r.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
         // r.setRequestHeader('Content-Type', 'application/json')
         r.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
         r.onreadystatechange = function () {
            if( 4 == r.readyState && 200 == r.status ){
               u.log("Success u.post",r)
               if ("function" == typeof ok) {
                  u.sending = false
                  ok(JSON.parse(r.responseText))
               }
            }else if ( 4 == r.readyState && 200 != r.status ){
               u.log("ERROR u.post",r)
               if ("function" == typeof ko) {
                  u.sending = false
                  ko(r)
               }
            } else {
               //sending some parts
            }
         };
         u.log('JSON.stringify(params)',JSON.stringify(params))
         // r.send(JSON.stringify(params));
         r.send(u.serialize(params));
      }
   }
   u.get = function(url,params,ok,ko){
      var r = new XMLHttpRequest(); 
      r.open("GET", url); //,true
      r.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      r.onreadystatechange = function () {
         if( 4 == r.readyState && 200 == r.status ){
            u.log("Success u.post",r)
            if ("function" == typeof ok) {
               ok(JSON.parse(r.responseText))
            }
         }else if ( 4 == r.readyState && 200 != r.status ){
            u.log("ERROR u.post",r)
            if ("function" == typeof ko) {
               ko(r)
            }
         } else {
            //sending some parts
         }
      };
      u.log('GET JSON.stringify(params)', JSON.stringify(params))
      r.send(u.serialize(params));
   }

 return u;
}())
var bauConstants = (function(u){
   var c = {}
   // c.strings = {
   //   errorInvalidEmail: "Comprueba tu email.",
   //   errorDuplicated: 'Ya estabas suscrito',
   //   errorAlEnviarGeneral: 'There was an error',
   //   errorRequired:'Para votar, debes seleccionar tu camiseta favorita',
   //   success:'Thank You!'
   // }
  // HTML to inject when ready
   c.injectors = {}
   //Formulario suscripción
   c.injectors['.suscribeWrapper'] = {
      'noinject-html': '   <p class="titleSuscribe info">\
                      We are working in amazing designs. <br> Do you want to be notified?\
                  </p>\
                  <div class="error">\
                  </div>\
                  <div class="success">\
                  </div>\
                  <form action="#" method="POST" class="suscribe">\
                      <input style="font-size: 18px;" class="email" type="email" name="email" placeholder="Email" required><!--\
                      !--><!--input type="submit" value="SEND MY EMAIL" class="enviar"/!-->\
                      <input type="image" src="" />\
                      <div class="privacidadWrapper">\
                      <input checked type="checkbox" id="privacidad" name="privacidad" class="privacidad">\
                      <label for="privacidad">\
                      I want to get information\
                      and I want to be part of Hard&amp;Class database. <a class="marronOscuro" href="#">Terms & Conditions.</a>\
                      </label>\
                      </div>\
                  </form>\
               ',
      'listen': 'submit',
      'inputs': {
         // id: {selector, [validation properties]}
         '_id':{
            selector: ".email",
            validation: ["id"]
         },
         'email':{
            selector: ".email",
            validation: ['email']
         },
         'privacidad':{
            selector: "input[type='checkbox']:checked",
            validation: ['required']
         }
      },
      'url': 'newsletter',
      'strings': {
         errorInvalidEmail: "Check your email email.",
         errorDuplicated: 'You were already registered.',
         errorAlEnviarGeneral: 'There was an error',
         errorRequired:'Check all the fields',
         success:'<p>Welcome to Hard&Class</p>'
       }
   }

   c.injectors['.voteWrapper'] = {
      'html': '',
      'listen': 'submit',
      'inputs': {
         'votacion_1': {
            selector: "input[type='radio']:checked",
            validation: ['required']
         }
      },
      'url': 'votes',
      'strings': {
         errorInvalidEmail: "Check your email email.",
         errorDuplicated: 'You were already registered.',
         errorAlEnviarGeneral: 'There was an error',
         errorRequired:'First you must select a T-Shirt',
         success:'<p>Thank you!, We have heard your opinion!</p>'
       },
      'callback': function(callbackOriginal,e,s){
         var voteHtml = document.querySelector(s).innerHTML

         callbackOriginal(e,s,function(data,successAlEnviarOriginal){
            u.get('https://forms-baulen.rhcloud.com/hardandclass/votes',{},function (data) {
              //Success get statistics
              u.log('//Success get statistics')
              //Remove all inputs
              Array.prototype.slice.call(document.querySelectorAll(s+" input")).forEach(function(e,i){e.remove()})
              //Show Thank You
              document.querySelector(s+" .success").innerHTML = c.injectors[s].strings["success"]
              document.querySelector(s+" .success").style.display = "block"
              document.querySelector(s).classList.add("success")
              //insert percents.
              // var total = data.reduce((p,c) => ({sum:p.sum+c.sum})).sum
              
              if (data.length > 0 && "undefined" != typeof data[0].sum) {
                  function contadorHTML(s,number){
                     u.log('s',s,'number',number)
                     var el = document.querySelector(s)
                     if (null != el){
                      el.dataset.number = number //Math.round(number*1000)/10
                      var counter = 0;
                      (function updateCounter(){
                         el.innerHTML = counter
                         incremento = 1
                         counter = Math.round((counter+incremento)*10)/10
                         if(counter<el.dataset.number){
                            setTimeout(updateCounter,40)
                         }
                      })();
                     }
                  }
                  for (var i in data){
                     // contadorHTML('.productVoted'+data[i]._id,data[i].sum/total)
                     contadorHTML('.productVoted'+data[i]._id,data[i].sum)
                  }
              }

            },function () {
              //error 

            })

         },
         function(){
            u.log('error')
         })
      }
   }
 return c;
}(baUtils));

(function (u,c) {
   var m = {
      _this:null,
      init: function() {
         _this = this
         // INIT
         document.addEventListener("DOMContentLoaded", function(){
            u.log("ready")
            _this.ready()
         })
         return this;
      }
   }.init()

   m.ready = function(e) {
      _this.injectHTML()
      _this.listenHTML()
   }
   m.injectHTML = function(){
      for (var s in c.injectors) {
         //AddGeneral class
         var el = document.querySelector(s)
         if (el) {
            el.classList.add("bauForm")
            //InjectHtml
            if (c.injectors[s].html) {
              el.innerHTML += c.injectors[s].html || "<!--"+s+"!-->"              
            }
         }else{
            //No existe en el Dom lo borramos
            delete c.injectors[s]
         }
      }
   }
   m.listenHTML = function() {
      function addListener(s, injector){
         document.querySelector(s).addEventListener(injector.listen || "submit",
                                                    function(e){
                                                      e.preventDefault()
                                                      if ("function" == typeof injector.callback) {
                                                         injector.callback(_this.listenerSubmitCallback,e,s)
                                                      }else{
                                                         _this.listenerSubmitCallback(e,s)
                                                      }
                                                    })
      }
      for (var s in c.injectors) {
         addListener(s,c.injectors[s])
      }
   }
   m.hideErrors = function (s) {
      var selectorError = ".error"
      u.log('hideErrors',s,selectorError)
      u.log('selectorError).innerHTML',selectorError.innerHTML)
      document.querySelector(s+' '+ selectorError).innerHTML = "";
      document.querySelector(s+' '+ selectorError).style.display = "none";
      document.querySelector(s).classList.remove("error")
   }
   m.showErrors = function (s,errors) {
     var selectorError = ".error"
     document.querySelector(s+' '+ selectorError).innerHTML = ""
     for (var i in errors){
      document.querySelector(s+' '+ selectorError).innerHTML += '<p>'+errors[i]+'</p>'
     }
     document.querySelector(s+' '+ selectorError).style.display = "block";
     document.querySelector(s).classList.add("error")
   }
   m.errorAlEnviarGeneral = function (s,errors) {
      u.log("ERROR errorAlEnviarGeneral");
      _this.showErrors(s,[c.injectors[s].strings.errorAlEnviarGeneral])
   }
   m.errorDuplicated = function (s,errors) {
      u.log("ERROR Duplicado");
     _this.showErrors(s,[c.injectors[s].strings.errorDuplicated])
   }
   m.successAlEnviar = function (s) {
     u.log("successAlEnviar",s);
      document.querySelector(s).classList.add("success")
      var fadeOutElements = [".info", "form", ".error"].map(function(e){return s+' '+e})
      var fadeInElements = [".success"].map(function(e){return s+' '+e})
      var injectHtml = {
         ".error" : "",
         ".success" : c.injectors[s].strings.success
      }
      // FadeOut
      Array.prototype.slice.call(document.querySelectorAll(fadeOutElements)).forEach(function(e,i){
         e.style.display = "none"
      });
      // FadeIn
      Array.prototype.slice.call(document.querySelectorAll(fadeInElements)).forEach(function(e,i){
         e.style.display = "block"
      });
      // Inject Html
      for(var k in injectHtml){
         var element = document.querySelector(s+' '+k)
         if (element) {
            element.innerHTML = injectHtml[k]
         }
      }
   }
   m.listenerSubmitCallback =  function(e,s,successFunc,errorFunc){
     successFunc = ("function" == typeof successFunc)?successFunc:null;
     errorFunc = ("function" == typeof errorFunc)?errorFunc:null;
     e.preventDefault();
     // var emailVar = $("#email").val();
     var params = {}
     var errors = [];
     for (var inputID in c.injectors[s].inputs) {
         var input = c.injectors[s].inputs[inputID]
         var inputHtmlElement = document.querySelector(s+" "+input.selector)
         u.log("seleccionando, input.selector , inputHtmlElement:",input.selector,inputHtmlElement)
         u.log("'undefinded' == typeof inputHtmlElement || null == inputHtmlElement, typeof inputHtmlElement",'undefinded' == typeof inputHtmlElement, null == inputHtmlElement,typeof inputHtmlElement)
         if('undefinded' == typeof inputHtmlElement || null == inputHtmlElement) {
            //
            if (input.validation.indexOf("required")>=0) {
                  errors.push(c.injectors[s].strings.errorRequired)
            }
         }else{
            // Inputs that are Subelements of selector s
            params[inputID] = inputHtmlElement.value            
            if (input.validation.indexOf("email")>=0) {
               if (!u.isEmail(params[inputID])) {
                  errors.push(c.injectors[s].strings.errorInvalidEmail)
               }
            }
         }
     }

     if (0 == errors.length) {
         u.log('submiting',params);
           u.post("//forms-baulen.rhcloud.com/hardandclass/"+c.injectors[s].url, params , function( data ) {
            if (1 == data.insertedCount) {
               _this.hideErrors(s)
                if (successFunc) {
                  successFunc(data,_this.successAlEnviar)
                }else{
                  _this.successAlEnviar(s);
                }
            }else{
             // Error
             if (data.writeErrors) {
               u.log('calling to errorDuplicated',s,errors)
                _this.errorDuplicated(s,errors);
                if (errorFunc) {
                  errorFunc(errors)
                }
             }else{
               u.log('calling to errorAlEnviarGeneral',s,errors)
               _this.errorAlEnviarGeneral(s,errors);
               if (errorFunc) {
                 errorFunc(errors)
               }
             }
            }
         })

     }else{

        _this.showErrors(s,errors);
        if (errorFunc) {
          errorFunc(errors)
        }
     }
      return false;
   }
}(baUtils,bauConstants));


//OUR RULES PAGE

if (jQuery) {
  function ready() {
    if (1 == $('body.layout-ourrules').length) {
      $( ".accordion" ).accordion();
      $( "#tabs" ).tabs();
    }
  }
  (function ($) {
    $( document ).ready(ready);
  })(jQuery)
}


// Opportunities
if (jQuery) {
  function clickFIlter(e) {
    e.preventDefault();
    var dataFilter = "";
    dataFilter = $(this).data('filter')
    jQuery(".productsnocarrusel > div.grid__item").fadeOut()
    jQuery(".productsnocarrusel > div.grid__item"+dataFilter).fadeIn()

  }
  function ready() {
    if (1 == $('.new-gallery-menuWrapper').length) {
      $(".linkFilter").on('click',clickFIlter)
    }
  }
  (function ($) {
    $( document ).ready(ready);
  })(jQuery)
}